import { observer } from 'mobx-react';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import FilterStore from '../../../../Builder/ExperienceCatalog/FilterTemplate/Store';
import { FilterOptionData } from '../../../../Builder/ExperienceCatalog/Types';
import { T, TPlainTextKey } from '../../../../../../../../Translations';

interface Props {
  sectionKey: string;
  titleKey: TPlainTextKey;
  filterStore: FilterStore;
  options: FilterOptionData[];
  isExpanded: boolean;
  onToggleSection: (sectionKey: string) => void;
  onOptionClick: (option: FilterOptionData) => void;
  isOptionActive: (value: string) => boolean;
  intercomTarget: string;
}

function FilterSection({
  sectionKey,
  titleKey,
  filterStore,
  options,
  isExpanded,
  onToggleSection,
  onOptionClick,
  isOptionActive,
  intercomTarget,
}: Props) {
  const activeCount = filterStore.state.filter.options.length;

  return (
    <div>
      <button
        onClick={() => onToggleSection(sectionKey)}
        className="w-full flex items-center justify-between mb-3"
      >
        <div className="flex items-center gap-2">
          <span style={{ fontWeight: 'var(--font-weight-medium)' }}>
            <T kind={titleKey} />
          </span>
          {activeCount > 0 && (
            <span
              className="px-2 py-0.5 bg-[#ECF1F3] text-[#43798F] rounded-full"
              style={{ fontSize: 'var(--text-xs)', fontWeight: 'var(--font-weight-medium)' }}
            >
              {activeCount}
            </span>
          )}
        </div>
        {isExpanded ? (
          <ChevronDownIcon className="w-4 h-4" />
        ) : (
          <ChevronRightIcon className="w-4 h-4" />
        )}
      </button>

      {isExpanded && (
        <div className="flex flex-wrap gap-2">
          {options.map((option) => (
            <button
              key={option.value}
              onClick={() => onOptionClick(option)}
              className={`px-3 py-1.5 rounded-md border transition-all ${
                isOptionActive(option.value)
                  ? 'bg-[#ECF1F3] text-[#43798F] border-border'
                  : 'bg-white text-gray-700 border-gray-300 hover:border-border'
              }`}
              style={{ fontSize: 'var(--text-sm)' }}
              data-intercom-target={intercomTarget}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default observer(FilterSection);
